import { Timelapse, timelapseCreateSchema, TimelapseCreateSchema } from "@/lib/types/timelapse";
import { Button, Checkbox, Group, Stack, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { zod4Resolver } from "mantine-form-zod-resolver";
import { useState } from "react";

type Props = {
  areaId: number;
  currentTimelapse?: Timelapse;
  onSubmit: (timelapse: TimelapseCreateSchema) => void;
  close: () => void;
}

export const TimelapseFormCreate = ({ areaId, currentTimelapse, onSubmit, close }: Props) => {
  const [checked, setChecked] = useState(false)
  const [checkError, setCheckError] = useState("")

  const form = useForm<TimelapseCreateSchema>({
    initialValues: {
      areaId,
      name: "",
      description: "",
    },
    validate: zod4Resolver(timelapseCreateSchema),
  })

  const handleSubmit = async () => {
    if (form.validate().hasErrors) return

    if (currentTimelapse && !checked) {
      setCheckError("Checkbox is required")
      return
    }

    onSubmit(form.values)
  }

  return (
    <Stack>
      <TextInput
        label="Name"
        placeholder="Dandelion"
        {...form.getInputProps("name")}
      />
      <Textarea
        label="Description"
        placeholder="A purple dandelion"
        autosize
        minRows={2}
        maxRows={6}
        {...form.getInputProps("description")}
      />
      {currentTimelapse && (
        <Checkbox
          label="I acknowledge that the current timelapse will be stopped"
          description={`Timelapse ${currentTimelapse.name} will be stopped and replaced by this timelapse\nIt's not possible to resume the old timelapse afterwards.`}
          error={checkError}
          checked={checked}
          onChange={e => setChecked(e.currentTarget.checked)}
        />
      )}
      <Group justify="end">
        <Button onClick={close} variant="outline">
          Cancel
        </Button>
        <Button onClick={handleSubmit}>
          Submit
        </Button>
      </Group>
    </Stack>
  )
}
